/**
 * Trustpilot: load the TrustBox bootstrap on the first interaction instead of on page load.
 * The micro star sits in the trust bar at the top of every page, so loading it when a widget
 * comes into view would still load it right away. Until then the widget shows its fallback link.
 */
const SCRIPT_SRC = "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
const INTERACTION_EVENTS = ["scroll", "pointerdown", "pointermove", "touchstart", "keydown"];

const loadScript = () => {
    INTERACTION_EVENTS.forEach((event) => window.removeEventListener(event, loadScript));

    const script = document.createElement("script");
    script.src = SCRIPT_SRC;
    script.async = true;
    document.head.appendChild(script);
};

if (document.querySelector(".trustpilot-widget")) {
    INTERACTION_EVENTS.forEach((event) =>
        window.addEventListener(event, loadScript, { once: true, passive: true }),
    );
}
